<template>
  <div class="home">
    <headTitle> </headTitle>
    <div class="bome-bg">
      <!-- <p class="title">互联网金融出海新方向</p> -->
      <img src="@/assets/home-text.png" class="title">
      <div class="title-1">
        <p>踏浪科技是一家专注于于海外金融流量+科技+支付+风控的全领域闭环金融科技公司。</p>
        <p>我们致力于成为出海金融科技公司的标杆，用技术改变世界。</p>
      </div>
      <div class="add-me" @click="goUser()">
        <span>加入我们</span>
        <img src="@/assets/home-r.png" class="home-r">
      </div>
      <img src="@/assets/home-sb.png" class="home-sb">
    </div>
    <div class="img-box">
      <img src="@/assets/home-3.png" class="home-3">
      <div class="home-img-box">
        <div class="home-img">
          <img src="@/assets/home-1.png" class="home-1">
          <div class="img-box-title">
            踏浪立足于科技，打破出海金融业务屏障，完成以流量，科技，<br>
            支付和风控为中心的全领域业务闭环。我们是金融移动出海领域的先行者，<br>
            3年不到成为印尼最大的金融科技平台，合作客户上百家，<br>
            月撮合交易额过亿美金。<br>
          </div>
        </div>
        <img src="@/assets/home-2.png" class="home-2">
      </div>
    </div>
    <div class="memorabilia">
      <img src="@/assets/homelsty.png" class="homelsty">
      <!-- <img src="@/assets/home-4.png" class="home-4">
      <div class="step-box">
        <p class="time-1">2017</p>
        <div class="steps">
          <p>2017.8 Firestorm先后在深圳和武汉成立</p>
          <p>2017.9 首款产品Casheasy上线GooglePlay印尼地区</p>
          <p>2017.12 Cashcash Pro上线GooglePlay印尼地区，并登顶GooglePlay财务应用最新免费榜</p>
          <p>2018</p>
          <p>2018.2 获得融360和梅花天使的数百万美元Pre-A轮融资</p>
          <p>2018.6 Cashcash Pro和贷款机构打通全流程，实现用户体验闭环</p>
          <p>2018.11获得CCV、清科创投、真格基金近千万美元A轮融资</p>
          <p>2019</p>
          <p>2019.3 Cashcash Pro获得印尼监管机构OJK颁发的运营牌照</p>
          <p>2019.8 Uatas（印尼）获得印尼监管机构OJK颁发的现金贷运营牌照</p>
          <p>2019.10 MoneyPay聚合支付系统上线</p>
          <p>2019.11 Cashcash Pro成为印尼最大的金融智选平台</p>
          <p>2019.12 公司营收规模破千万，首次实现年度盈利</p>
          <p>2020</p>
          <p>2020.2 Zeus 现金（印尼）贷系统上线</p>
          <p>2020.4 Osiris（印尼）风控系统上线</p>
          <p>2020.12 Cashcash Pro（印度）上线GooglePlay印度地区</p>
          <p>2020.12 公司营收规模过亿，年度盈利破千万</p>
          <p>2021</p>
          <p>2021 To be continued</p>
        </div>
      </div> -->
    </div>
    <div class="target">
      <div class="target-box">
        <img src="@/assets/home-7.png" class="home-7">
        <div class="target-img">
          <img src="@/assets/home-6.png" class="home-6">
          <div class="target-title">
            做互联网金融出海方向的水与电，赋能合作伙伴。<br>
            以用户价值为中心，将信念与责任融入产品和服务之中。<br>
            推动科技创新，助力行业升级，促进海外金融产业的蓬勃发展。
          </div>
        </div>
      </div>
      <img src="@/assets/home-8.png" class="home-8">
    </div>
    <div class="culture">
      <img src="@/assets/home-11.png" class="home-11">
      <div class="culture-box">
        <div class="home-img">
          <img src="@/assets/home-9.png" class="home-9">
          <div class="culture-title">
            自驱专注，合作双赢<br>
            积极进取，持续进步<br>
            敢突破，有担当，每个人都是自己的leader<br>
            实事求是，高效专注<br>
            开放协同，多元兼容，合作双赢<br>
          </div>
        </div>
        <img src="@/assets/home-10.png" class="home-10">
      </div>
    </div>
    <div class="office">
      <p class="place">
        <img src="@/assets/home-16.png" class="home-16">
      </p>
      <img src="@/assets/home-13.png" class="home-13">
      <div class="culturea-box">
        <p>
          <img src="@/assets/home-14.png" class="home-14">
          <span>武汉：武汉市东湖新技术开发区光谷大道3号激光工程设计总部二期研发楼06幢06单元15层5号（Y497） </span>
        </p>
        <!-- <p>
          <img src="@/assets/home-14.png" class="home-14">
          <span>深圳：深圳市南山区科技园德赛科技大厦2603B室</span>
        </p> -->
        <p class="office-tele">海外地区：</p>
        <p>
          <img src="@/assets/home-14.png" class="home-14">
          <span>印尼：APL Tower Lantai 9 Unit T8 <br>
            Jl. Letjen S Parman Kav.28, Grogol Pertamburan,<br>
            Jakarta Barat 11470</span>
        </p>
        <p>
          <img src="@/assets/home-15.png" class="home-15">
          <span>联系邮箱:career@wavetec-globe.com</span>
        </p>
      </div>
    </div>
    <foot :menuIndex='0'></foot>
  </div>
</template>

<script>
export default {
  name: "Home",
  methods: {
    goUser() {
      this.$router.push({ path: '/welfare' })
    }
  }
};
</script>
<style lang="less" scoped>
@minwidth: 768px;

.bome-bg {
  width: 100%;
  height: 1080px;
  display: block;
  overflow: hidden;
  background: url('../assets/home.png') no-repeat;
  background-size: 100% 100%;
  text-align: center;

  .title {
    font-family: Source-KeynoteartHans-Regular;
    font-size: 50px;
    color: #ffffff;
    text-align: center;
    margin-top: 316px;
    font-style: oblique;
    font-weight: bold;
    width: 505px;
  }

  .title-1 {
    font-size: 22px;
    color: #ffffff;
    text-align: center;
    margin-top: 67px;

    p {
      &:nth-child(2) {
        margin-top: 20px;
      }
    }
  }

  .add-me {
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    width: 300px;
    height: 60px;
    line-height: 60px;
    background: #ffa317;
    font-size: 20px;
    color: #ffffff;
    text-align: center;
    margin-top: 96px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    span {
      margin-left: 20px;
    }

    .home-r {
      width: 54px;
    }
  }

  .home-sb {
    width: 34px;
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    top: 990px;
  }
}

.img-box {
  margin-top: 240px;
  padding: 0px 300px;
  height: 608px;
  position: relative;

  @media screen and (max-width: @minwidth) {
    padding: 0px 0px 0px 100px;
  }

  .home-3 {
    width: 875px;
    position: absolute;
    top: 559px;
    left: 552px;
  }

  .home-img-box {
    display: flex;
    justify-content: space-between;
    position: relative;
    align-items: center;

    .home-img {
      .home-1 {
        width: 240px;
        margin-top: 160px;

        @media screen and (max-width: @minwidth) {
          margin-top: 10px;
          line-height: 60px;
        }
      }

      .img-box-title {
        margin-top: 80px;
        font-size: 18px;
        color: #666666;
        text-align: left;
        line-height: 40px;

        @media screen and (max-width: @minwidth) {
          margin-top: 10px;
          line-height: 60px;
        }
      }
    }

    .home-2 {
      width: 704px;
    }
  }
}

.memorabilia {
  margin-top: 453px;
  // padding: 0px 300px;
  position: relative;
  text-align: center;
  display: flex;
  align-items: center;
  flex-direction: column;

  .homelsty {
    width: 1920px;
  }

  .step-box {
    background: url('../assets/admin.png') no-repeat;
    background-size: 100% 100%;
    width: 1288px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .home-4 {
    width: 158px;
  }

  .time-1 {
    margin-top: 66px;
    margin-bottom: 30px;
    font-size: 20px;
    color: #333333;
    font-weight: bold;
  }

  .steps {
    width: 10px;
    height: 842px;
    background: url('../assets/step.png') no-repeat;
    background-size: 100% 100%;
    position: relative;

    p {
      font-size: 18px;
      color: #666666;
      text-align: left;
      position: absolute;
      min-width: 600px;

      @media screen and (max-width: @minwidth) {
        line-height: 50px;
        min-width: 900px;
      }

      &:nth-child(1) {
        left: 48px;
        top: -10px;

        @media screen and (max-width: @minwidth) {
          left: 55px;
        }
      }

      &:nth-child(2) {
        text-align: right;
        right: 24px;
        top: 30px;

        @media screen and (max-width: @minwidth) {
          right: 55px;
        }
      }

      &:nth-child(3) {
        left: 24px;
        top: 70px;

        @media screen and (max-width: @minwidth) {
          left: 55px;
        }
      }

      &:nth-child(4) {
        top: 120px;
        font-size: 20px;
        color: #333333;
        font-weight: bold;
        left: 0;
        right: 0;
        margin: auto;
        transform: translateX(-50%);
        text-align: center;
      }

      &:nth-child(5) {
        text-align: right;
        right: 24px;
        top: 170px;

        @media screen and (max-width: @minwidth) {
          right: 55px;
        }
      }

      &:nth-child(6) {
        left: 24px;
        top: 210px;

        @media screen and (max-width: @minwidth) {
          left: 55px;
        }
      }

      &:nth-child(7) {
        text-align: right;
        right: 24px;
        top: 250px;

        @media screen and (max-width: @minwidth) {
          right: 55px;
        }
      }

      &:nth-child(8) {
        top: 300px;
        font-size: 20px;
        color: #333333;
        font-weight: bold;
        left: 0;
        right: 0;
        margin: auto;
        transform: translateX(-50%);
        text-align: center;
      }

      &:nth-child(9) {
        left: 24px;
        top: 350px;

        @media screen and (max-width: @minwidth) {
          left: 55px;
        }
      }

      &:nth-child(10) {
        text-align: right;
        right: 24px;
        top: 390px;

        @media screen and (max-width: @minwidth) {
          right: 55px;
        }
      }

      &:nth-child(11) {
        left: 24px;
        top: 430px;

        @media screen and (max-width: @minwidth) {
          left: 55px;
        }
      }

      &:nth-child(12) {
        text-align: right;
        right: 24px;
        top: 470px;

        @media screen and (max-width: @minwidth) {
          right: 55px;
        }
      }

      &:nth-child(13) {
        left: 24px;
        top: 510px;

        @media screen and (max-width: @minwidth) {
          left: 55px;
        }
      }

      &:nth-child(14) {
        top: 550px;
        font-size: 20px;
        color: #333333;
        font-weight: bold;
        left: 0;
        right: 0;
        margin: auto;
        transform: translateX(-50%);
        text-align: center;
      }

      &:nth-child(15) {
        text-align: right;
        right: 24px;
        top: 605px;

        @media screen and (max-width: @minwidth) {
          right: 55px;
        }
      }

      &:nth-child(16) {
        left: 24px;
        top: 645px;

        @media screen and (max-width: @minwidth) {
          left: 55px;
        }
      }

      &:nth-child(17) {
        text-align: right;
        right: 24px;
        top: 685px;

        @media screen and (max-width: @minwidth) {
          right: 55px;
        }
      }

      &:nth-child(18) {
        left: 24px;
        top: 725px;

        @media screen and (max-width: @minwidth) {
          left: 55px;
        }
      }

      &:nth-child(19) {
        top: 770px;
        font-size: 20px;
        color: #333333;
        font-weight: bold;
        left: 0;
        right: 0;
        margin: auto;
        transform: translateX(-50%);
        text-align: center;
      }

      &:nth-child(20) {
        left: 24px;
        top: 825px;

        @media screen and (max-width: @minwidth) {
          right: 55px;
        }
      }
    }
  }
}

.target {
  margin-top: 417px;
  padding: 0px 300px;
  position: relative;

  @media screen and (max-width: @minwidth) {
    padding: 0px 100px 0px 0px;
  }

  .home-8 {
    width: 875px;
    position: absolute;
    top: 559px;
    left: 402px;
  }

  .target-box {
    display: flex;
    justify-content: space-between;
    position: relative;
    align-items: center;
    z-index: 1;

    .home-7 {
      width: 704px;
    }

    .target-img {
      // width: 550px;
      margin-left: 50px;

      .home-6 {
        width: 124px;
        margin-top: 160px;

        @media screen and (max-width: @minwidth) {
          margin-top: 60px;
        }
      }

      .target-title {
        margin-top: 80px;
        font-size: 18px;
        color: #666666;
        text-align: left;
        line-height: 80px;
      }
    }
  }
}

.culture {
  margin-top: 240px;
  padding: 0px 300px;
  height: 608px;
  position: relative;

  @media screen and (max-width: @minwidth) {
    padding: 0px 0px 0px 100px;
  }

  .home-11 {
    width: 875px;
    position: absolute;
    top: 559px;
    left: 552px;
  }

  .culture-box {
    display: flex;
    justify-content: space-between;
    position: relative;
    align-content: center;

    .home-img {
      .home-9 {
        width: 124px;
        margin-top: 160px;
      }

      .culture-title {
        margin-top: 80px;
        font-size: 18px;
        color: #666666;
        text-align: left;
        line-height: 40px;

        @media screen and (max-width: @minwidth) {
          line-height: 60px;
        }
      }
    }

    .home-10 {
      width: 704px;
      max-height: 608px;
    }
  }
}

.office {
  width: 100%;
  margin-top: 204px;
  height: 712px;
  background: url('../assets/home-12.png') no-repeat;
  background-size: 100% 100%;
  position: relative;

  .place {
    position: absolute;
    top: 34px;
    width: 100%;
    font-weight: bold;
    text-align: center;
    font-size: 20px;
    color: #ffffff;
    font-style: oblique;

    .home-16 {
      width: 83px;
    }
  }

  .home-13 {
    position: absolute;
    top: 153px;
    left: 300px;
    width: 759px;
  }

  .culturea-box {
    position: absolute;
    background-color: #ffffff;
    width: 529px;
    top: 0px;
    bottom: 0px;
    margin: auto;
    right: 200px;
    height: 320px;
    padding: 26px 36px;
    overflow: hidden;
    line-height: unset;

    .office-tele {
      font-size: 18px;
      color: #000000;
      font-weight: bold;
      margin: 24px 0px;
    }

    p {
      margin-top: 20px;

      &:nth-child(1) {
        display: flex;
        align-items: center;
      }

      &:nth-child(2) {
        display: flex;
        align-items: center;
      }
    }

    .home-14 {
      width: 18px;
    }

    .home-15 {
      width: 18px;
    }

    span {
      font-size: 16px;
      color: #333333;
      margin-left: 10px;
    }
  }
}
</style>
